import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import domain from "../../reusecomponent/domain";
import { useNavigate } from "react-router-dom";
import { update } from "../../redux/userserviceslice";
import { getToken, removeToken } from "../../whatsapp/function/token";
import { TokenVerify } from "../../routing/ApplicationProtectedRouting";
import { setAccessToken } from "../../redux/tokenslice";
import BlankLoader from "../../CommerceManager/component/BlankLoader";
import { WorningToastContainer } from "../../whatsapp/function/CustomFunction";

export function UserServices({children}) {

  const navigate = useNavigate();
  const Accesstoken = useSelector((state) => state.Token.value);
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(true);

  useEffect(()=> {
    if(!Accesstoken){
        const token = getToken();
        if(token){
          let TokenValidate = TokenVerify(token);
          if(TokenValidate.status){
              dispatch(setAccessToken(token))
          }else{
            setLoader(false);
          }
        }else{
          setLoader(false);
        }
    }else if(Accesstoken){
      fetchUserServices();
    }

  },[Accesstoken]);

  const fetchUserServices = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${Accesstoken}`);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
      };
      const response = await fetch(`${domain()}/users`, requestOptions);
      if (!response.ok) {
        removeToken();
        navigate('/');
        return;
      }
      const result = await response.json();
      if (result.status) {
        let parsedData;
        try {
          const firstDecode = atob(result.data);
          const secondDecode = atob(firstDecode);
          parsedData = JSON.parse(secondDecode);
          dispatch(update(parsedData));
        } catch (e) {
          WorningToastContainer("Internal Server Problem");
        }
      }
    } catch (e) {
        WorningToastContainer("Internal Server Problem");
    } finally {
      setLoader(false);
    }
  };

  if (loader) {
    return <BlankLoader />;
  }else{
    return <>{children}</>;
  }
}
